import * as angular from "angular";
import { ToastUtils } from "../../helper/toast.helper";

let VerificationCodeComponent = {
    selector: "vcVerificationCode",
    templateUrl: "/angular/components/login/verification-code.component.html",
    bindings: {
        verification: "=?",
        cancelFn: "&?",
        successFn: "&?",
    },
    controller: class VerificationCodeController {
        // * bindings for typescript compiler *
        public cancelFn?: any;
        public successFn?: any;
        public verification?: any;
        // ************************************

        private readonly $scope: any;
        private readonly __time_zone: string;

        private toast: ToastUtils;
        private __env: any;
        private $http: any;

        public loading = false;
        public verification_error: string | null = null;
        public login: any;
        public code: string;

        constructor(
            $scope: any,
            __env: any,
            $http: any,
            __time_zone: string,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.$http = $http;
            this.__env = __env;
            this.__time_zone = __time_zone;
            this.toast = ToastUtils;
        }

        $onInit() {
            this.verification.code = null;

            this.$scope.$on("focusVerificationCode", () => {
                document.getElementById("verificationcode").focus();
            });

            this.$scope.$watch(
                () => this.verification.code,
                (newValue: string | null, oldValue: string | null) => {
                    if (newValue !== oldValue && newValue.length == 6) {
                        this.sendVerificationForm();
                    }
                },
                true
            );
        }

        sendVerificationForm(region?: string): void {
            document.getElementById("verificationcode").blur();
            this.verification_error = null;
            this.loading = true;

            let url = "";
            if (angular.isDefined(region)) {
                url =
                    "https://" +
                    region +
                    "." +
                    this.__env.host +
                    this.__env.apiUrl() +
                    "/login/verification-code?timezone=" +
                    encodeURIComponent(this.__time_zone);
            } else {
                url =
                    this.__env.apiUrl() +
                    "/login/verification-code?timezone=" +
                    encodeURIComponent(this.__time_zone);
            }

            this.$http.post(url, this.verification).then(
                (response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        this.loading = false;
                        this.successFn();
                    } else if (angular.isDefined(json.region)) {
                        this.sendVerificationForm(json.region);
                    } else {
                        this.verification_error = json.message;
                        this.loading = false;
                    }
                },
                () => {
                    this.loading = false;
                    this.verification_error = "An error has occurred";
                }
            );
        }

        cancelVerification(): void {
            this.verification = null;
            this.verification_error = null;
            this.loading = false;
            this.cancelFn();
        }

        copyCode(text: string): void {
            let copyElement = document.createElement("textarea");
            copyElement.style.position = "fixed";
            copyElement.style.opacity = "0";
            copyElement.textContent = text;
            let body = document.getElementsByTagName("body")[0];
            body.appendChild(copyElement);
            copyElement.select();
            document.execCommand("copy");
            body.removeChild(copyElement);
            this.toast.success("Code copied");
        }
    },
};

angular
    .module("login")
    .component(VerificationCodeComponent.selector, VerificationCodeComponent);
